import { BadgeIndianRupee, FileText, IndianRupee, LayoutDashboard, LayoutList, Package, Package2, PackageOpen, UsersRound, Warehouse, } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  const location = useLocation();
  const [storeMenu, setStoreMenu] = useState(false);
  const [transaction, setTransaction] = useState(false);
  const [report, setReport] = useState(false);

  const handleTransaction = () => {
    setTransaction(!transaction);
  };

  const handleReport = () => {
    setReport(!report);
  };

  const handleStore = () => {
    setStoreMenu(!storeMenu);
  };

  useEffect(() => {
    if (
      location.pathname === "/main-store/user/unit-management" ||
      location.pathname === "/main-store/user/manage-unit" ||
      location.pathname === "/main-store/user/category-management" ||
      location.pathname === "/main-store/user/manage-category" ||
      location.pathname === "/main-store/user/transport-management" ||
      location.pathname === "/main-store/user/item-company-management" ||
      location.pathname === "/main-store/user/manage-item-company" ||
      location.pathname === "/main-store/user/payment-management" ||
      location.pathname === "/main-store/user/manage-transport" ||
      location.pathname === "/main-store/user/manage-payment-method" ||
      location.pathname === "/main-store/user/inventory-location-management" ||
      location.pathname === "/main-store/user/manage-inventory-location" ||
      location.pathname === "/main-store/user/party-group-management" ||
      location.pathname === "/main-store/user/manage-party-group" ||
      location.pathname === '/main-store/user/general-master-management' ||
      location.pathname === '/main-store/user/manage-general-master' ||
      location.pathname === '/main-store/user/manage-general-master-management' ||
      location.pathname === "/main-store/user/class-management" ||
      location.pathname === "/main-store/user/manage-class" ||
      location.pathname === "/main-store/user/moc-management" ||
      location.pathname === "/main-store/user/manage-moc" ||
      location.pathname === "/main-store/user/schedule-management" ||
      location.pathname === "/main-store/user/manage-schedule" ||
      location.pathname === "/main-store/user/drawing-management" ||
      location.pathname === "/main-store/user/view-drawing"
    ) {
      setStoreMenu(true);
    }

    if (
      location.pathname === "/main-store/user/purchase-request-management" ||
      location.pathname === "/main-store/user/manage-purchase-request" ||
      location.pathname === "/main-store/user/view-purchase-request" ||

      location.pathname === "/main-store/user/purchase-order-management" ||
      location.pathname === "/main-store/user/manage-purchase-order" ||
      location.pathname === "/main-store/user/view-purchase-order" ||
      location.pathname === "/main-store/user/amend-purchase-order" ||

      location.pathname === "/main-store/user/purchase-receive-management" ||
      location.pathname === '/main-store/user/manage-purchase-receive' ||
      location.pathname === '/main-store/user/view-purchase-receive' ||

      location.pathname === "/main-store/user/purchase-return-management" ||
      location.pathname === "/main-store/user/manage-purchase-return" ||
      location.pathname === "/main-store/user/view-purchase-return" ||

      location.pathname === "/main-store/user/issue-management" ||
      location.pathname === "/main-store/user/manage-issue" ||
      location.pathname === "/main-store/user/view-issue" ||

      location.pathname === "/main-store/user/issue-return-management" ||
      location.pathname === "/main-store/user/manage-issue-return" ||
      location.pathname === "/main-store/user/view-issue-return" ||

      location.pathname === "/main-store/user/scrap-management" ||
      location.pathname === "/main-store/user/manage-scrap" ||
      location.pathname === "/main-store/user/view-scrap" ||

      location.pathname === "/main-store/user/delivery-challan-management" ||
      location.pathname === "/main-store/user/manage-delivery-challan" ||
      location.pathname === "/main-store/user/view-delivery-challan" ||

      location.pathname === "/main-store/user/other-issue-management" ||
      location.pathname === "/main-store/user/manage-other-issue" ||
      location.pathname === "/main-store/user/view-other-issue" ||

      location.pathname === "/main-store/user/other-purchase-management" ||
      location.pathname === "/main-store/user/manage-other-purchase" ||
      location.pathname === "/main-store/user/view-other-purchase"
    ) {
      setTransaction(true);
    }

    if (
      location.pathname === '/main-store/user/item-ledger' ||
      location.pathname === '/main-store/user/reorder-items' ||
      location.pathname === '/main-store/user/po-pending-management' ||
      location.pathname === '/main-store/user/pr-pending-management' ||
      location.pathname === '/main-store/user/issue-report' ||
      location.pathname === '/main-store/user/master-report'
    ) {
      setReport(true);
    }
  }, [location.pathname]);

  return (
    <div className="sidebar" id="sidebar">
      <div className="sidebar-inner slimscroll side-bar-scroll">
        <div id="sidebar-menu" className="sidebar-menu">
          <ul>
            <li>
              <Link
                to="/main-store/user/dashboard"
                className={`${location.pathname === "/main-store/user/dashboard" ? "active" : ""
                  }`}
              >
                <span className="menu-side">
                  <LayoutDashboard className="Dash-iCon" />
                </span>
                <span>Dashboard</span>
              </Link>
            </li>

            <li className="submenu">
              {/* eslint-disable jsx-a11y/anchor-is-valid */}
              <a
                className={`${storeMenu === true ? "subdrop active" : ""}`}
                onClick={handleStore}
                style={{ cursor: "pointer" }}
              >
                <span className="menu-side">
                  <Warehouse className="Dash-iCon" />
                </span>
                <span> Store </span> <span className="menu-arrow" />
              </a>
              <ul style={{ display: storeMenu ? "block" : "none" }}>
                <li>
                  <Link to="/main-store/user/unit-management" className={`${location.pathname === "/main-store/user/unit-management" ||
                    location.pathname === "/main-store/user/manage-unit" ? "active" : ""}`} >
                    Unit
                  </Link>

                  <Link
                    to="/main-store/user/category-management" className={`${location.pathname === "/main-store/user/category-management" ||
                      location.pathname === "/main-store/user/manage-category" ? "active" : ""}`}
                  >
                    Item Category
                  </Link>

                  <Link
                    to="/main-store/user/item-company-management" className={`${location.pathname === "/main-store/user/item-company-management" ||
                      location.pathname === "/main-store/user/manage-item-company" ? "active" : ""}`}
                  >
                    Item Company
                  </Link>

                  <Link
                    to="/main-store/user/transport-management"
                    className={`${location.pathname === "/main-store/user/transport-management" ||
                      location.pathname === "/main-store/user/manage-transport" ? "active" : ""}`}
                  >
                    Transport
                  </Link>

                  <Link
                    to="/main-store/user/payment-management"
                    className={`${location.pathname === "/main-store/user/payment-management" ||
                      location.pathname === "/main-store/user/manage-payment-method" ? "active" : ""}`}
                  >
                    Payment Method
                  </Link>

                  <Link
                    to="/main-store/user/inventory-location-management" className={`${location.pathname === "/main-store/user/inventory-location-management" || location.pathname === "/main-store/user/manage-inventory-location" ? "active" : ""}`}>
                    Inventory Location
                  </Link>

                  <Link
                    to="/main-store/user/party-group-management"
                    className={`${location.pathname === "/main-store/user/party-group-management" || location.pathname === "/main-store/user/manage-party-group" ? "active" : ""}`}>
                    Party Group
                  </Link>

                  <Link
                    to="/main-store/user/general-master-management"
                    className={`${location.pathname === "/main-store/user/general-master-management" || location.pathname === "/main-store/user/manage-general-master" ? "active" : ""}`}>
                    General Master
                  </Link>

                  {/* <Link
                    to="/main-store/user/schedule-management"
                    className={`${location.pathname === "/main-store/user/schedule-management" ||
                      location.pathname === "/main-store/user/manage-schedule" ? "active" : ""}`}>
                    Schedule
                  </Link>

                  <Link
                    to="/main-store/user/class-management"
                    className={`${location.pathname === "/main-store/user/class-management" ||
                      location.pathname === "/main-store/user/manage-class" ? "active" : ""}`}>
                    Class
                  </Link>

                  <Link
                    to="/main-store/user/moc-management"
                    className={`${location.pathname === "/main-store/user/moc-management" ||
                      location.pathname === "/main-store/user/manage-moc" ? "active" : ""}`}>
                    MOC
                  </Link> */}

                  <Link
                    to="/main-store/user/drawing-management"
                    className={`${location.pathname === "/main-store/user/drawing-management" ||
                      location.pathname === "/main-store/user/view-drawing" ? "active" : ""}`}>
                    Drawing
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/main-store/user/party-management"
                className={`${location.pathname === "/main-store/user/party-management" || location.pathname === "/main-store/user/manage-party" ? "active" : ""}`}
              >
                <span className="menu-side">
                  <UsersRound className="Dash-iCon" />
                </span>
                <span>Party</span>
              </Link>
            </li>

            <li>
              <Link
                to="/main-store/user/item-management"
                className={`${location.pathname === "/main-store/user/item-management" || location.pathname === "/main-store/user/manage-item" ? "active" : ""}`}>
                <span className="menu-side">
                  <LayoutList className="Dash-iCon" />
                </span>
                <span>Item</span>
              </Link>
            </li>

            <li className="submenu">
              {/* eslint-disable jsx-a11y/anchor-is-valid */}
              <a
                className={`${transaction === true ? "subdrop active" : ""}`}
                style={{ cursor: "pointer" }}
                onClick={handleTransaction}>
                <span className="menu-side">
                  <BadgeIndianRupee className="Dash-iCon" />
                </span>
                <span> Transaction </span> <span className="menu-arrow" />
              </a>
              <ul style={{ display: transaction ? "block" : "none" }}>
                <Link
                  to="/main-store/user/purchase-request-management"
                  className={`${location.pathname === "/main-store/user/purchase-request-management"
                    || location.pathname === '/main-store/user/manage-purchase-request' ||
                    location.pathname === '/main-store/user/view-purchase-request' ? "active" : ""}`}
                >
                  Purchase Request
                </Link>

                <Link
                  to="/main-store/user/purchase-order-management"
                  className={`${location.pathname === "/main-store/user/purchase-order-management" ||
                    location.pathname === '/main-store/user/manage-purchase-order' ||
                    location.pathname === '/main-store/user/view-purchase-order' ||
                    location.pathname === '/main-store/user/amend-purchase-order'
                    ? "active" : ""}`}
                >
                  Purchase Order
                </Link>

                <Link
                  to="/main-store/user/purchase-receive-management"
                  className={`${location.pathname === "/main-store/user/purchase-receive-management" ||
                    location.pathname === '/main-store/user/manage-purchase-receive' ||
                    location.pathname === '/main-store/user/view-purchase-receive' ? "active" : ""}`}
                >
                  Purchase Recieving
                </Link>

                <Link
                  to="/main-store/user/purchase-return-management"
                  className={`${location.pathname === "/main-store/user/purchase-return-management" ||
                    location.pathname === '/main-store/user/manage-purchase-return' ||
                    location.pathname === '/main-store/user/view-purchase-return' ? "active" : ""}`}
                >
                  Purchase Return
                </Link>

                <Link to="/main-store/user/issue-management"
                  className={`${location.pathname === '/main-store/user/issue-management' ||
                    location.pathname === '/main-store/user/manage-issue' ||
                    location.pathname === '/main-store/user/view-issue'
                    ? 'active' : ''}`} >
                  Issue
                </Link>
                <Link to="/main-store/user/issue-return-management"
                  className={`${location.pathname === '/main-store/user/issue-return-management' ||
                    location.pathname === '/main-store/user/manage-issue-return' ||
                    location.pathname === '/main-store/user/view-issue-return'
                    ? 'active' : ''}`} >
                  Issue Return
                </Link>
                <Link to="/main-store/user/scrap-management"
                  className={`${location.pathname === '/main-store/user/scrap-management' ||
                    location.pathname === '/main-store/user/manage-scrap' ||
                    location.pathname === '/main-store/user/view-scrap'
                    ? 'active' : ''}`} >
                  Scrap
                </Link>
                <Link to="/main-store/user/delivery-challan-management"
                  className={`${location.pathname === '/main-store/user/delivery-challan-management' ||
                    location.pathname === '/main-store/user/manage-delivery-challan' ||
                    location.pathname === '/main-store/user/view-delivery-challan'
                    ? 'active' : ''}`} >
                  Delivery Challan
                </Link>

                {/* <Link to="/main-store/user/other-issue-management"
                  className={`${location.pathname === '/main-store/user/other-issue-management' ||
                    location.pathname === '/main-store/user/manage-other-issue' ||
                    location.pathname === '/main-store/user/view-other-issue'
                    ? 'active' : ''}`} >
                  Other Issue
                </Link>
                <Link to="/main-store/user/other-purchase-management"
                  className={`${location.pathname === '/main-store/user/other-purchase-management' ||
                    location.pathname === '/main-store/user/manage-other-purchase' ||
                    location.pathname === '/main-store/user/view-other-purchase'
                    ? 'active' : ''}`} >
                  Other Purchase
                </Link> */}
              </ul>
            </li>

            <li>
              <Link
                to="/main-store/user/store-quotation"
                className={`${location.pathname === "/main-store/user/store-quotation" || location.pathname === "/main-store/user/manage-store-quotation" ? "active" : ""}`}>
                <span className="menu-side">
                  <IndianRupee className="Dash-iCon" />
                </span>
                <span>Store Quotation</span>
              </Link>
            </li>

            {/* <li>
              <Link
                to="/main-store/user/stock-management"
                className={`${location.pathname === "/main-store/user/stock-management" ||
                  location.pathname === "/main-store/user/manage-stock" ? "active" : ""}`}
              >
                <span className="menu-side">
                  <Package2 className="Dash-iCon" />
                </span>
                <span>Stock</span>
              </Link>
            </li> */}

            <li>
              <Link
                to="/main-store/user/stock-with-value-management"
                className={`${location.pathname === "/main-store/user/stock-with-value-management" ||
                  location.pathname === "/main-store/user/manage-stock-with-value" ? "active" : ""}`}
              >
                <span className="menu-side">
                  <PackageOpen className="Dash-iCon" />
                </span>
                <span>Stock</span>
              </Link>
            </li>

            {/* <li>
              <Link
                to="/main-store/user/stock-plat-management"
                className={`${location.pathname === "/main-store/user/stock-plat-management" ? "active" : ""}`}
              >
                <span className="menu-side">
                  <Package className="Dash-iCon" />
                </span>
                <span>Stock Plat List</span>
              </Link>
            </li> */}

            <li className="submenu">
              {/* eslint-disable jsx-a11y/anchor-is-valid */}
              <a
                className={`${report === true ? "subdrop active" : ""}`}
                style={{ cursor: "pointer" }}
                onClick={handleReport}>
                <span className="menu-side">
                  <FileText className="Dash-iCon" />
                </span>
                <span> Report </span> <span className="menu-arrow" />
              </a>
              <ul style={{ display: report ? "block" : "none" }}>
                <Link to="/main-store/user/pr-pending-management" className={`${location.pathname === '/main-store/user/pr-pending-management' ? "active" : ""}`}>
                  PR Pending
                </Link>
                <Link to="/main-store/user/po-pending-management" className={`${location.pathname === '/main-store/user/po-pending-management' ? "active" : ""}`}>
                  PO Pending
                </Link>
                <Link to="/main-store/user/item-ledger" className={`${location.pathname === '/main-store/user/item-ledger' ? "active" : ""}`}>
                  Item Ledger
                </Link>
                <Link to="/main-store/user/reorder-items" className={`${location.pathname === '/main-store/user/reorder-items' ? "active" : ""}`}>
                  Re-order Items
                </Link>
                <Link to="/main-store/user/issue-report" className={`${location.pathname === '/main-store/user/issue-report' ? "active" : ""}`}>
                  Issue Report
                </Link>
                <Link to="/main-store/user/master-report" className={`${location.pathname === '/main-store/user/master-report' ? "active" : ""}`}>
                  Master Report
                </Link>
              </ul>
            </li>

          </ul>
        </div>
      </div >
    </div >
  );
};

export default Sidebar;